import { useCallback } from 'react';

import { useSearchParams } from 'react-router-dom';

/**
 * Active tab of a page kept in `?tab=`, so links and the browser's back button land on the same
 * tab. Unknown values fall back to `defaultTab`; the default tab is written as an absent param.
 *
 * @param {string[]} tabKeys
 * @param {string} defaultTab
 * @returns {[string, (tab: string) => void]}
 */
export function useUrlTab(tabKeys, defaultTab) {
	const [searchParams, setSearchParams] = useSearchParams();
	const param = searchParams.get('tab');
	const activeTab = tabKeys.includes(param) ? param : defaultTab;

	const setActiveTab = useCallback(
		(tab) =>
			setSearchParams(
				(prev) => {
					const next = new URLSearchParams(prev);
					if (tab === defaultTab) next.delete('tab');
					else next.set('tab', tab);
					return next;
				},
				{ replace: true },
			),
		[setSearchParams, defaultTab],
	);

	return [activeTab, setActiveTab];
}
